import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_thai_chi_walking_fem_christmas_sale~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_thai_chi_walking_fem_christmas_sale'
					),
			},
		},
	},
]

export default config
